import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { appIcons, appImages } from "../../assets";
import GlobalButton from "../../components/button";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import BoxContainer from "../../components/container/boxContainer";
import SubService from "../../json/SubServices.json";
import CustomizedAccordions from "../../components/accordian";
import Label from "../../components/label";
import InputField from "../../components/InputField";
import { t } from "i18next";

const SendRequest = () => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          backgroundImage: `url(${appImages.serviceBgImg1})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        {/* wave image */}
        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      </Box>

      <Box position={"absolute"} top={{ xs: 130, sm: 150 }} left={0} right={0}>
        <Container
          sx={{
            maxWidth: "1100px !important",
            position: "relative",
            zIndex: 999,
          }}
        >
          <GlobalButton
            handleClickBtn={() => navigate(-1)}
            variant={"outlined"}
            btnText={"Back"}
            startIcon={<img src={appIcons.whiteArrowBackIcon} width={30} />}
            styleProps={{
              color: "text.white",
            }}
          />

          <Typography
            variant="heading_pr"
            component={"h1"}
            maxWidth={700}
            margin={"auto"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={5}
          >
            Book Your Service Now
          </Typography>
          <Box>
            <img src={appImages.stepperStepThreeImg} width={"100%"} />
          </Box>
          <BoxContainer sx={{ mt: 2 }}>
            <Typography variant="h6" textTransform={"capitalize"}>
              {t("bookNow")}
            </Typography>
          </BoxContainer>

          <BoxContainer
            sx={{
              mt: 3,
              borderRadius: 2.5,
            }}
          >
            <Stack mb={4}>
              <Typography
                variant="h6"
                lineHeight={"normal"}
                textTransform={"capitalize"}
              >
                {t("checkout")}
              </Typography>
              <Typography variant="body1">
                {t("source")} :{" "}
                <span
                  style={{
                    color: " #EA580C",
                  }}
                >
                  {t("onlineBookingService")}
                </span>
              </Typography>
            </Stack>

            <Typography
              variant="h6"
              lineHeight={"normal"}
              mb={2}
              textTransform={"capitalize"}
            >
              {t("allServices")}
            </Typography>

            {SubService.map((item, index) => {
              return (
                <Box key={index}>
                  {/* <Typography variant="h6" mb={2}>
                    {item.name}
                  </Typography> */}
                  <Stack gap={1.5}>
                    {item.services.slice(0, 2).map((val, _ind) => {
                      return (
                        <CustomizedAccordions
                          data={val}
                          index={_ind}
                          mainIndex={index}
                        />
                      );
                    })}
                  </Stack>
                </Box>
              );
            })}

            <Stack mt={4}>
              <FormControlLabel
                required
                control={<Checkbox />}
                label={t("serviceProviderGmail")}
              />
              <Stack>
                <Label text={t("noteMessage")} required />
                <InputField
                  placeholder={t("enterNoteMessage")}
                  multiline
                  rows={3}
                />
              </Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} my={3}>
              <Typography variant="h6" flexGrow={1} fontWeight={600}>
                Total
              </Typography>
              <Stack direction={"row"} alignItems={"center"} gap={3}>
                <Typography variant="body2">2hr & 30 min</Typography>
                <Typography variant="h6" flexGrow={1} fontWeight={600}>
                  $ 240 USD
                </Typography>
              </Stack>
            </Stack>

            <Stack my={3}>
              <GlobalButton
                btnText={t("sendWorkerReq")}
                handleClickBtn={() => {
                  navigate(`/all-service`);
                }}
                styleProps={{
                  width: "max-content",
                  alignSelf: "center",
                }}
              />
            </Stack>
          </BoxContainer>
        </Container>
        <AppFooter bgcolor={true} />
      </Box>
    </>
  );
};

export default SendRequest;
